/**
 * Account pending events API types shared between API and UI.
 */
export class AccountEventsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async getPending() {
        return this.client.get('/api/account/events/pending');
    }
    async dismiss(params) {
        return this.client.post('/api/account/events/dismiss', params);
    }
}
//# sourceMappingURL=account-events-api.js.map